export default __webpack_public_path__ + "static/article-manage-your-finances-3dfa10d39bac14b32d90719f7599229b.jpg";